import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const DigitalOperations = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  QualityAssurance: lazy(() => import('./containers/QualityAssurance/index.tsx')),
  QualityAssurance2: lazyNamed(() => import('./containers/QualityAssurance2/index.tsx'), 'QualityAssurance2'),
  CampaignManagement: lazy(() => import('./containers/CampaignManagement/index.tsx')),

  Approval: {
    CreativesList: lazy(() => import('./containers/Approval/containers/CreativesList/index.tsx')),
    CreativeDraftsPage: lazy(() => import('./containers/Approval/containers/CreativeDraftsPage/index.ts')),
    Layout: lazy(() => import('./containers/Approval/components/Layout.tsx')),
  },

  ScreenshotManagement: {
    Campaigns: lazy(() => import('./containers/ScreenshotManagement/containers/Campaigns/index.tsx')),
    Approvals: lazy(() => import('./containers/ScreenshotManagement/containers/Approvals/index.tsx')),
    Done: lazy(() => import('./containers/ScreenshotManagement/containers/Done/index.tsx')),
    Hidden: lazy(() => import('./containers/ScreenshotManagement/containers/Hidden/index.tsx')),
    Layout: lazy(() => import('./containers/ScreenshotManagement/components/Layout.tsx')),
  },
};

export { DigitalOperationStatus } from './types.ts';

export default DigitalOperations;
